import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import VidyaUpasnaLogo from "../assets/VidyaUpasna.jpg";
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';
import ViewImageAndTextQuetionBank from '../components/ViewImageAndTextQuetionBank';

const CompetitiveExamViewQuestion = () => {
    const authorizedAxios = generateAxiosInstance();
    const [questions, setQuestion] = useState([]);
    const [editId, setEditId] = useState(null);
    const [competitiveExamList, setCompetitiveExamList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [bookList, setBookList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);


    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["q_level", "q_type", "question"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const initialFilterState = {
        competitiveExamNameMasterId: '',
        competitiveExamBookMasterId: '',
        competitiveLessonMasterId: '',
        competitiveTopicMasterId: '',
        competitiveSubTopicMasterId: '',
        competitiveSubTopicName: '',
        subjectMasterId: ''
    }

    const [filter, setFilter] = useState(initialFilterState);
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const getApiUrl = () => {
        if (filter.competitiveExamNameMasterId !== "" && filter.competitiveExamBookMasterId !== "" && filter.subjectMasterId !== "") {
            let apiUrl = `/get-competitive-question-bank?`;
            if (filter.q_id) {
                apiUrl += `q_id=${filter.q_id}&`;
            }
            if (filter.q_type) {
                apiUrl += `q_type=${filter.q_type}&`;
            }
            if (filter.q_level) {
                apiUrl += `q_level=${filter.q_level}&`;
            }
            if (filter.competitiveExamNameMasterId) {
                apiUrl += `competitiveExamNameMasterId=${filter.competitiveExamNameMasterId}&`;
            }
            if (filter.competitiveExamBookMasterId) {
                apiUrl += `competitiveExamBookMasterId=${filter.competitiveExamBookMasterId}&`
            }
            if (filter.competitiveLessonMasterId) {
                apiUrl += `competitiveLessonMasterId=${filter.competitiveLessonMasterId}&`;
            }
            if (filter.competitiveTopicMasterId) {
                apiUrl += `competitiveTopicMasterId=${filter.competitiveTopicMasterId}&`;
            }
            if (filter.competitiveSubTopicMasterId) {
                apiUrl += `competitiveSubTopicMasterId=${filter.competitiveSubTopicMasterId}&`;
            }
            if (filter.subjectMasterId) {
                apiUrl += `subjectMasterId=${filter.subjectMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        }
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (filter.competitiveExamNameMasterId !== "" && filter.competitiveExamBookMasterId !== "" && filter.subjectMasterId !== "") {
                setQuestion(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (filter.competitiveExamNameMasterId !== "" && filter.competitiveExamBookMasterId !== "" && filter.subjectMasterId !== "") {
            getQuestionAnswerList();
        }
    }, [filter, refresh]);

    const getQuestionAnswerList = () => {
        if (filter.competitiveExamNameMasterId !== "" && filter.competitiveExamBookMasterId !== "" && filter.subjectMasterId !== "") {
            let apiUrl = getApiUrl();
            // if (filter.q_id) {
            //     apiUrl += `q_id=${filter.q_id}&`;
            // }
            // if (filter.q_type) {
            //     apiUrl += `q_type=${filter.q_type}&`;
            // }
            // if (filter.q_level) {
            //     apiUrl += `q_level=${filter.q_level}&`;
            // }
            // if (filter.competitiveExamNameMasterId) {
            //     apiUrl += `competitiveExamNameMasterId=${filter.competitiveExamNameMasterId}&`;
            // }
            // if (filter.competitiveExamBookMasterId) {
            //     apiUrl += `competitiveExamBookMasterId=${filter.competitiveExamBookMasterId}&`
            // }
            // if (filter.competitiveLessonMasterId) {
            //     apiUrl += `competitiveLessonMasterId=${filter.competitiveLessonMasterId}&`;
            // }
            // if (filter.competitiveTopicMasterId) {
            //     apiUrl += `competitiveTopicMasterId=${filter.competitiveTopicMasterId}&`;
            // }
            // if (filter.competitiveSubTopicMasterId) {
            //     apiUrl += `competitiveSubTopicMasterId=${filter.competitiveSubTopicMasterId}&`;
            // }
            // if (filter.subjectMasterId) {
            //     apiUrl += `subjectMasterId=${filter.subjectMasterId}&`;
            // }
            // apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setQuestion(response.data.data)
                    // console.log(response.data.data);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(questions, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(questions.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > questions.length) {
            endIndex = questions.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(questions.slice(startIndex, endIndex));
    }, [questions, currPage, itemsPerPage]);

    const getViewList = () => {
        if (filter.competitiveExamNameMasterId !== "" && filter.competitiveExamBookMasterId !== "" && filter.subjectMasterId !== "") {
            let apiUrl = getApiUrl();
            // const apiUrl = `/get-topic-master-list`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setQuestion(response.data.data);
                    setAddNew(!addNew);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        text: errorMsg
                    })
                });
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-competitive-exam-names`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setCompetitiveExamList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                setCompetitiveExamList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputFilterChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveLessonMasterId: '',
                competitiveTopicMasterId: ''
            }
        })


        const apiUrl2 = `/get-competitive-exam-book-master?competitiveExamNameMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setBookList(response.data.data)
                console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                setBookList([]);
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });

    }

    const handleBookChanges = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveLessonMasterId: '',
                competitiveTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                setSubjectList([]);
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });

    }

    const handleSubjectChanges = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
            }
        })

        const apiUrl = `/get-competitive-lesson?competitiveExamBookMasterId=${filter.competitiveExamBookMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                setLessonList([]);
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }


    const handleLessonChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveTopicMasterId: ''
            }
        })
        const apiUrl = `/get-competitive-topic?competitiveLessonMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }


    const handleTopicChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
            }
        })
        const apiUrl = `/get-competitive-sub-topic?competitiveExamNameMasterId=${filter.competitiveExamNameMasterId}&competitiveExamBookMasterId=${filter.competitiveExamBookMasterId}&competitiveLessonMasterId=${filter.competitiveLessonMasterId}&competitiveTopicMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubtopicList(response.data.result)
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                setSubtopicList([]);
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }

    const handleReset = () => {
        setFilter(initialFilterState);
        setQuestion([]);
        setBookList([]);
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubtopicList([]);
        setDisplayedData([]);
        setCurrPage(1);
        setTotalPages(0);
        setStartIndex(null);
        setSaveId(null);
        setItemsPerPage(10);
        setVisible(false);
    }


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>View Competitive Question Bank</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i>View Competitive Question Bank</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam Name :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveExamNameMasterId' onChange={handleSyllabusChange} value={filter.competitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam  Structure</option>
                                                        {
                                                            competitiveExamList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.examName}</option>
                                                            })
                                                        }
                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveExamBookMasterId' onChange={handleBookChanges} value={filter.competitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChanges} value={filter.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                console.log("syllabus", syllabus);
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveLessonMasterId' onChange={handleLessonChange} value={filter.competitiveLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.competitiveLessonName}</option>
                                                            })
                                                        }
                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveTopicMasterId' onChange={handleTopicChange} value={filter.competitiveTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.competitiveTopicName}</option>
                                                            })
                                                        }
                                                    </select>

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveSubTopicName' onChange={handleInputFilterChange} value={filter.competitiveSubTopicName}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subtopicList?.map((subtopic) => {
                                                                return <option value={subtopic.id}>{subtopic.competitiveSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                {!editId && <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleReset}>Reset</button>
                                                    </div>
                                                </div>}



                                                {filter.subjectMasterId !== "" &&

                                                    <div className='row'>
                                                        <div className="separator"></div>
                                                        <div className="d-grid gap-2 mt-2">
                                                            {displayedData.length > 0 ?
                                                                <>
                                                                    <div className='search_btn_row'>
                                                                        <input
                                                                            className="form-control mr-sm-2"
                                                                            type="Search"
                                                                            placeholder="Search"
                                                                            value={searchValue}
                                                                            onChange={handleEmptySearch}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter') {
                                                                                    handleSearch();
                                                                                }
                                                                            }}
                                                                        />
                                                                        <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                    </div>
                                                                    <div class="generate_pdf_question_paper_report_block" id="examReportContent">
                                                                        <div class="generate_pdf_question_paper_heading">
                                                                            <div class="generate_pdf_question_paper_logo">
                                                                                {/* <img src={displayedData[0]?.instituteMasterDetails?.logoPath} alt="Institute Logo" /> */}
                                                                                <img src={VidyaUpasnaLogo} alt="VidyaUpasna Logo" />
                                                                            </div>
                                                                            <div class="text_center">
                                                                                {/* <h6>{displayedData[0]?.instituteMasterDetails?.instituteName}</h6> */}
                                                                                {/* <h4>{displayedData[0]?.sectionMasterDetails?.sectionName}</h4> */}
                                                                                <h4>Vidya Upasna</h4>
                                                                            </div>
                                                                            <div class="generate_pdf_question_paper_logo">
                                                                                {/* <img src={displayedData[0]?.instituteMasterDetails?.logoPath} alt="Institute Logo" /> */}
                                                                                <img src={VidyaUpasnaLogo} alt="VidyaUpasna Logo" />
                                                                            </div>
                                                                        </div>

                                                                        <div class="generate_pdf_question_paper_report_code">
                                                                            <span class="line"></span>
                                                                        </div>

                                                                        <div class="generate_pdf_question_paper_details">
                                                                            <span>Competitive Exam: {displayedData[0]?.competitiveExamNameMasterDetails?.examName}</span>
                                                                            <span>Book: {displayedData[0]?.competitiveExamBookMasterDetails?.bookName}</span>
                                                                            <span>Subject: {displayedData[0]?.subjectMasterDetails?.subjectName}</span>
                                                                            {/* <span>Lesson: {pdfDetails?.examTotalMarks}</span> */}
                                                                        </div>


                                                                        <ol className="generate_pdf_question_paper_generated_pdf_total_question">
                                                                            {displayedData?.map((question, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {index == 0 && <div class="generate_pdf_question_paper_details">
                                                                                            <span>Lesson: {question?.competitiveLessonMasterDetails?.competitiveLessonName}</span>
                                                                                        </div>}
                                                                                        {index !== 0 && (displayedData[index - 1].competitiveLessonMasterId !== question.competitiveLessonMasterId) && <div class="generate_pdf_question_paper_details">
                                                                                            <span>Lesson: {question?.competitiveLessonMasterDetails?.competitiveLessonName}</span>
                                                                                        </div>}
                                                                                        <li key={index} className="generate_pdf_question_paper_question pdf-question-paper-listed-outer">
                                                                                            {/* <p>{question.question}</p> */}
                                                                                            {/* <p> */}
                                                                                            {/* <strong>{startIndex + index + 1}. </strong> */}
                                                                                            {/* <ViewImageAndTextQuetionBank inputString={question.question} onViewImage={onViewImage} /> */}
                                                                                            {/* </p> */}

                                                                                            <div className='card-question-header'>
                                                                                                <span className="list-number">{startIndex + index + 1}.</span>
                                                                                                <ViewImageAndTextQuetionBank inputString={question.question} onViewImage={onViewImage} />
                                                                                            </div>
                                                                                            <ul className='margin-top-10'>
                                                                                                {['option_a', 'option_b', 'option_c', 'option_d'].map((optionKey, optionIndex) => {
                                                                                                    const optionLetter = String.fromCharCode(65 + optionIndex); // A, B, C, D
                                                                                                    // const isCorrect = question.ans.split(',').includes(String.fromCharCode(97 + optionIndex)); // Checking if the answer matches
                                                                                                    return (
                                                                                                        <li key={optionIndex} data-option={optionLetter} /*className={isCorrect ? "correct" : ""}*/>
                                                                                                            {/* {question[optionKey]} */}
                                                                                                            <ViewImageAndTextQuetionBank inputString={question[optionKey]} onViewImage={onViewImage} />
                                                                                                        </li>
                                                                                                    );
                                                                                                })}
                                                                                            </ul>
                                                                                            <p className="pdf-highlight"><strong>Correct Answer:</strong> {question.ans.toUpperCase()}</p>
                                                                                            <p className="pdf-highlight"><strong>Solution:</strong><ViewImageAndTextQuetionBank inputString={question.sol} onViewImage={onViewImage} /></p>
                                                                                        </li>
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </ol>

                                                                    </div>
                                                                    <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questions.length} />
                                                                </>
                                                                :
                                                                (<div className='row'>
                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                </div>)}
                                                        </div>
                                                    </div>

                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />


            {visible && <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni
            >
                <div className="book book-modal">
                    <div className='table-header-like'>Sub Topic Details</div>

                    <div className="page" dangerouslySetInnerHTML={{
                        __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>`
                    }}></div>

                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                        Close
                    </button>
                </div>
            </CModal>}

            {visibleImage && (
                <CModal
                    visible={visibleImage}
                    onClose={() => setVisibleImage(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <div className="book book-modal">
                        <div className='table-header-like'>Image</div>
                        {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                            Close
                        </button>
                    </div>
                </CModal>
            )}

        </>
    )
};

export default CompetitiveExamViewQuestion;
